export enum HMSWhiteboardState {
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
}
